<template>
    <div class="filter_wrapper">
        <div class="filter_wrapper_inner">
            <button
                class="btn_reset btn_close"
                type="button"
                @click="$emit('close-filters')"
            />
            <div class="filter_title">
                סינון לפי <span>({{ total }})</span>
            </div>
            <div class="filter_block">
                <single-filter
                    v-for="filter in displayableFilters"
                    :key="filter.id"
                    :filter="filter"
                    @attribute-clicked="onAttributeClick"
                />
                <div class="btn_wrapper text_center">
                    <button
                        class="btn btn_green"
                        type="button"
                        @click="applyFilters"
                    >
                        סינון
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SingleFilter from './SingleFilter';

export default {
    components: {
        SingleFilter
    },

    props: {
        filters: {
            type: Array,
            required: false,
            default: () => []
        },
        active: {
            type: Object,
            required: false,
            default: () => ({})
        },
        total: {
            type: Number,
            required: true
        },
        isLoan: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            prices: {
                name: 'מחיר',
                id: 'price',
                attributes: [
                    {
                        id: JSON.stringify({ max: 2500 }),
                        value: '25₪-0₪'
                    },
                    {
                        id: JSON.stringify({ min: 2500, max: 5000 }),
                        value: '50₪-25₪'
                    },
                    {
                        id: JSON.stringify({ min: 5000, max: 10000 }),
                        value: '100₪-50₪'
                    },
                    {
                        id: JSON.stringify({ min: 10000, max: 15000 }),
                        value: '150₪-100₪'
                    },
                    {
                        id: JSON.stringify({ min: 15000 }),
                        value: '+ 150₪'
                    }
                ]
            }
        };
    },

    computed: {
        displayableFilters() {
            if (this.isLoan) {
                return this.filters;
            }

            return [this.prices, ...this.filters];
        }
    },

    methods: {
        isActive(attributeId, filterId) {
            if (!this.active[filterId]) {
                return false;
            }

            return this.active[filterId].includes(attributeId);
        },

        onAttributeClick({ attributeId, filterId }) {
            const activeFilters = { ...this.active };

            if (this.isActive(attributeId, filterId)) {
                const index = activeFilters[filterId].indexOf(attributeId);
                activeFilters[filterId].splice(index, 1);

                if (!activeFilters[filterId].length) {
                    delete activeFilters[filterId];
                }

                return this.$emit('filters-changed', activeFilters);
            }

            if (!activeFilters[filterId]) {
                activeFilters[filterId] = [];
            }

            activeFilters[filterId].push(attributeId);

            this.$emit('filters-changed', activeFilters);
        },

        applyFilters() {
            this.$emit('filters-changed', this.active);
            this.$emit('close-filters');
        }
    }
};
</script>
